import Image from "next/image";
import { FaStar } from "react-icons/fa";
import styles from "./DownloadApp.module.css";
import { APP_STORE_LINKS, STORE_RATING } from "./downloadAppData";

function StoreRating() {
  return (
    <span className={styles.storeRatingValue}>{STORE_RATING}</span>
  );
}

export default function DownloadAdventure() {
  return (
    <section className={`standard-padding ${styles.heroSection}`}>
      <div className={styles.heroGrid}>
        <div className={styles.heroCopy}>
          <h1 className="standard-heading">
            Your Next Adventure Is Just A Tap Away!
          </h1>
          <p className={styles.heroDesc}>
            Book amazing travel experiences anytime, anywhere. Get exclusive
            deals, seamless bookings, and 24/7 support—all in one app.
          </p>

          <div className={styles.storeCards}>
            <a
              href={APP_STORE_LINKS.android}
              className={styles.storeCard}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Google Play"
            >
              <Image
                src="/download2.svg"
                alt=""
                width={28}
                height={28}
                className={styles.storeLogo}
              />
              <div className={styles.storeCardBody}>
                <span className={styles.storeCardLabel}>GET IT ON</span>
                <span className={styles.storeCardName}>Google Play</span>
                <span className={styles.storeRatingValue}>{STORE_RATING}</span>
              </div>
            </a>

            <a
              href={APP_STORE_LINKS.ios}
              className={styles.storeCard}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Get it on Apple Store"
            >
              <Image
                src="/app-store.png"
                alt=""
                width={28}
                height={28}
                className={styles.storeLogo}
              />
              <div className={styles.storeCardBody}>
                <span className={styles.storeCardLabel}>GET IT ON</span>
                <span className={styles.storeCardName}>Apple Store</span>
                <StoreRating />
              </div>
            </a>

            <div className={styles.qrCard}>
              <Image
                src="/NHQRCode.svg"
                alt="Scan QR code to download Next Holidays app"
                width={88}
                height={88}
                className={styles.qrImage}
              />
              <span className={styles.qrLabel}>Scan QR Code Here</span>
            </div>
          </div>
        </div>

        <iframe
          src="https://www.youtube.com/embed/MBU9nc5vsis"
          className={styles.DownloadAdventureDiv2}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    </section>
  );
}
